import { getAuthToken } from './browser_state';

const INSTANCE_PREFIX_REGEX = /^\/i\/([a-zA-Z0-9_-]+)(\/.*)?$/;

let cachedTenantId = null;
let cachedSlug = null;

export const getInstanceSlugFromPath = () => {
    const match = window.location.pathname.match(INSTANCE_PREFIX_REGEX);
    return match ? match[1] : null;
};

export const getInstancePrefix = () => {
    const slug = getInstanceSlugFromPath();
    return slug ? `/i/${slug}` : '';
};

export const buildPath = (path) => {
    const prefix = getInstancePrefix();
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${prefix}${normalized}`;
};

export const isUsingPathBasedTenancy = () => getInstanceSlugFromPath() !== null;

export const getCurrentInstanceSlug = () => {
    const pathSlug = getInstanceSlugFromPath();
    if (pathSlug) {
        localStorage.setItem('ticketing_instance_slug', pathSlug);
        return pathSlug;
    }
    return localStorage.getItem('ticketing_instance_slug');
};

export const clearInstanceSlug = () => {
    localStorage.removeItem('ticketing_instance_slug');
};

export const getTenantId = async (apiBaseUrl) => {
    const slug = getInstanceSlugFromPath();
    if (!slug) return null;
    if (cachedTenantId && cachedSlug === slug) return cachedTenantId;

    const headers = { 'X-Source-Host': window.location.host };
    const token = await getAuthToken();
    if (token) headers['Authorization'] = `Token ${token}`;

    try {
        const res = await fetch(`${apiBaseUrl}/api/v1/instances`, { headers });
        const data = await res.json();
        const instances = data.instances || data;
        const instance = (Array.isArray(instances) ? instances : []).find(i => i.slug === slug);
        if (instance?.id) {
            cachedTenantId = instance.id;
            cachedSlug = slug;
            return cachedTenantId;
        }
    } catch (e) {
        console.error('Failed to resolve tenant ID:', e);
    }
    return null;
};
